import styled from 'styled-components';
import { variant } from 'styled-system';
import ThemeUtilities from '../../../theme/ThemeUtilities';
import { ComponentVariants } from './type';

export const CreditCardHolderDetailsWrapper = styled.div<{
  variant?: ComponentVariants;
}>`
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(
        props,
        'CreditCardHolderDetails',
        'variant'
      )
    )};
`;

CreditCardHolderDetailsWrapper.defaultProps = {
  variant: 'regular',
};
